export const errorValidationKeys = {
    '1': [
        'data.firstName',
        'data.lastName',
        'data.phone',
        'data.email',
        'data.dateOfBirth',
        'data.gender',
        'data.language',
        'data.nationality',
        'data.passportExpirationDate',
        'maritalStatus',
        'workForm',
        'data.documents',
    ],
    '2': ['hasSwissAddress', 'swissAddress', 'hasAbroadAddress', 'abroadAddress'],
    '3': ['expensesForOptimization', 'mealAllowance', 'representativeAllowance'],
    '4': [
        'hasAdditionalAccidentInsurance',
        'accidentRate',
        'lossOfIncome',
        'hasCBA',
        'cba',
        'hasTreasury',
        'treasury',
        'paymentCurrency',
    ],
    '5': ['workTime', 'otherJob'],
};
export const getErrorKeys = (messages: { property: string }[]) => {
    return Array.from(
        new Set(
            Object.entries(errorValidationKeys).reduce<string[]>((acc, [key, fields]) => {
                if (messages.some((msg) => fields.some((field) => msg.property.includes(field)))) {
                    acc.push(key);
                }
                return acc;
            }, [])
        )
    );
};
export const getErrorKeysFromObj = (messages: Record<string, string>) => {
    return Array.from(
        new Set(
            Object.entries(errorValidationKeys).reduce<string[]>((acc, [key, fields]) => {
                if (Object.keys(messages).some((value) => fields.includes(value))) {
                    acc.push(key);
                }
                return acc;
            }, [])
        )
    );
};
